import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OmeApplication } from '../../interfaces/omeApplication';

export interface OmeApplicationState {
  applications: OmeApplication[],
  applyInProgress: boolean,
  loaded: boolean,
}

const initialState: OmeApplicationState = {
  applications: [],
  applyInProgress: false,
  loaded: false,
};

export const omeApplicationSlice = createSlice({
  name: 'omeApplication',
  initialState,
  reducers: {
    setOmeApplications: (state, action: PayloadAction<{ applications: OmeApplication[], applyInProgress?: boolean }>) => {
      const { applications, applyInProgress } = action.payload;
      state.applications = applications;
      if (applyInProgress !== undefined) state.applyInProgress = applyInProgress;
      state.loaded = true;
    },
    setOmeApplyInProgress: (state, action: PayloadAction<boolean>) => {
      state.applyInProgress = action.payload;
    },
  },
});

export const { setOmeApplications, setOmeApplyInProgress } = omeApplicationSlice.actions;

export default omeApplicationSlice.reducer;
